var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattlefield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72mm",
    height: "48mm",
    viewBox: "0 0 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h72v48H0z",
    style: {
      opacity: 1,
      fill: "#55d52a",
      fillOpacity: 1,
      strokeWidth: 0.282851
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 10,
    y: 8,
    ry: 2,
    style: {
      opacity: 1,
      fill: "#378c1c",
      fillOpacity: 1,
      strokeWidth: 0.199003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 50,
    y: 30,
    ry: 2,
    style: {
      opacity: 1,
      fill: "#1c678c",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21h8v1h-8z",
    style: {
      opacity: 1,
      fill: "#767676",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 17.7,
    y: 31.3,
    ry: 3,
    style: {
      opacity: 1,
      fill: "#575757",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 49.5,
    y: 3.9,
    rx: 2,
    style: {
      opacity: 1,
      fill: "#575757",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 26.7,
    y: 17.3,
    ry: 1,
    style: {
      opacity: 1,
      fill: "#e9d900",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 5.1,
    y: 31.8,
    ry: 3,
    style: {
      opacity: 1,
      fill: "#a67023",
      fillOpacity: 1,
      strokeWidth: 0.264583
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattlefield);
export default __webpack_public_path__ + "static/media/battlefield.e7f6dfe38d84dbd8b077b8b16f8db13f.svg";
export { ForwardRef as ReactComponent };